export default "__VITE_ASSET__DgP$DGbP__"